import React from 'react';
import { Cable, Network, Lightbulb, PhoneCall, Tv, BatteryCharging } from 'lucide-react';
import SectionHeader from './common/section-header';

const services = [
  {
    title: 'Elektroinstallationen',
    description: `Dietronik-Service bietet Ihnen die volle Bandbreite an Service und Leistungen im Bereich der Elektroinstallation.
Egal ob Neuinstallationen, Reparaturen oder Wartungen.
Inklusive Anmeldung beim EV und Abnahme.`,
    icon: Cable,
  },
  {
    title: 'Netzwerktechnik',
    description: `Dietronik-Service plant und wartet auch Ihre Netzwerk- und EDV-Systeme.
Wir vernetzen Sie für die Zukunft.`,
    icon: Network,
  },
  {
    title: 'Beleuchtungsystem',
    description: `Dieronik-Service ist Ihr Spezialist für moderne Beleuchtungstechnik.
Dazu gehören LED Beleuchtung, Sicherheits- und Notbeleuchtungsanlagen sowie auch Arbeitsplatz-Beleuchtung und Wohnraum-Beleuchtung.`,
    icon: Lightbulb,
  },
  {
    title: 'Sprechanlagen und Videoanlage',
    description: `Dietronik-Service bietet auch hier einen vollen Umfang an Dienstleistungen.
Dazu gehören Neuinstallationen und Reparaturen von Anlagen.`,
    icon: PhoneCall,
  },
  {
    title: 'TV/SAT-Anlagen',
    description: `Dietronik-Services Leistungsspektrum beinhaltet auch die Planung und Installation von Antennenanlagen.
Ob Kabel-TV oder Satelliten-Empfangssysteme, ob kleine Einheit oder komplexe Großanlagen.`,
    icon: Tv,
  },
  {
    title: 'Wallbox und Stromtankstellen / Photovoltaik',
    description: 'Dietronik-Service bietet eine individuelle Lösung für ihre Anlage.',
    icon: BatteryCharging,
  }
];

const ServicesSection = () => {
  return (
    <section id="services" className="py-20 bg-white">
      <div className="container">
        <SectionHeader 
          title="Unsere Dienstleistungen"
          description="Wir bieten eine umfassende Palette an Service- und Installationsdienstleistungen für Elektrotechnik an."
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 justify-center">
          {services.map((service, index) => (
            <div 
              key={index} 
              className="bg-white rounded-lg border-2 border-primary/30 shadow-lg p-6 transition-all duration-300 hover:scale-105 hover:shadow-xl hover:border-primary/50 group text-center"
            >
              <div className="bg-primary/10 p-3 rounded-full w-12 h-12 flex items-center justify-center text-primary mb-4 mx-auto transition-transform group-hover:scale-110">
                <service.icon size={24} />
              </div>
              <h3 className="text-xl font-semibold mb-3 transition-colors group-hover:text-primary/80 text-center">{service.title}</h3>
              <p className="text-paragraph text-justify text-align-last-none">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
